import {
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    Grid,
    IconButton,
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import MROButton from "components/buttons";
import { makeStyles } from "@material-ui/core/styles";
import exclamationIcon from "assets/exclamation.png"
import WarningIcon from "@material-ui/icons/Warning";
import LoadingIndicator from "components/universal/loading_indicator";
import { Document, Page, pdfjs } from "react-pdf";
import { ToastMessageContext } from "lib/contexts/message_context";
import { CommercialServices } from "lib/services/api/operaitons/WorkShop/TaskLibrary/commercial";
import { BASE_API_URL_BOXP } from "lib/constants";
import { useCroppedSecondPage } from "views/Operations/Base/Inprogress/Certification/useCroppedPage";
import { Close } from "@material-ui/icons";


pdfjs.GlobalWorkerOptions.workerSrc =
    `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


const useStyles = makeStyles((theme) => ({
    wrapper: {
        backgroundColor: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`,
        margin: "1% 0",
        display: "flex",
        "& button": {
            marginRight: theme.spacing(2),
            width: "200px",
            "& .MuiButton-label": {
                justifyContent: "space-between",
                width: "150px",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
            },
        },
    },
    input: {
        color: "#fff",
    },
    paper: {
        borderRadius: "5px",
        backgroundColor: "#fff",
        padding: theme.spacing(3),
        boxShadow: "0px 1px 4px #0000001A",
    },
    head: {
        marginTop: "20px",
        marginBottom: "10px",
    },
    error: {
        borderColor: "red",
    },
    svg: {
        filter: "invert(1)",
        height: 18,
        marginBottom: 2,
    },
    disableSwitch: {
        pointerEvents: "none",
    },
    disableField: {
        pointerEvents: "none",
        backgroundColor: "#F5F5F5",
    },
    message: {
        display: "flex",
        justifyContent: "flex-start",
        margin: theme.spacing(1)
    },
    modal: {
        "& .MuiDialog-paperWidthMd": {
            width: "563px",
        },
    }, modal1: {
        "& .MuiDialog-paperWidthMd": {
            width: "880px",
        },
    },
}));

const InfoRow = ({ label, value, underline = false }) => (
    <Grid xs={12} container style={{ marginBottom: "7px", marginLeft: "17px" }}>

        <Grid xs={2}>
            <Typography variant="subtitle2">{label}</Typography>
        </Grid>
        <Grid xs={7}>
            <Typography style={underline ? { textDecoration: 'underline' } : {}}>
                {value}
            </Typography>
        </Grid>
    </Grid>
);
function CreateApprovaCaution(props) {
    const classes = useStyles();
    const { open,
        workshopOrderId,
        handleClose,
        popupValues,
        setAcceptAll,
        acceptAll,
        handleSubmit,
        onClose,
        planningVerfication,
        tabName,
        width,
        payload

    } = props
    const [closureData, setClosureData] = useState({})
    const [preview, setPreview] = useState(false)
    const [selectedPdfUrl, setSelectedPdfUrl] = useState(null)
    const [loading, setLoading] = useState(false)
    const [totalPages, setTotalPages] = useState(1)
    const [disable, setDisable] = useState(false)

    const message = useContext(ToastMessageContext)

    const handlePopUp = (e) => {
        handleClose()
        handleSubmit(e, closureData?.approved_position_id)
    }

    let pdfUrl = selectedPdfUrl;

    // Call hook at top level
    const croppedPdfUrl = useCroppedSecondPage(pdfUrl);




    const getPreviewFile = async () => {
        setLoading(true)
        const params = {
            preview: true,
            approved: false
        }
        await CommercialServices.createNewApproval(params, payload)
            .then((res) => {
                if (res) {
                    setClosureData(res)
                }
            })
            .catch(() => {
                message.showToastMessage({
                    message: "Something went wrong. Try again!!",
                    variant: "error",
                });
            })
            .finally(() => {
                setLoading(false)
            });



    }

    useEffect(() => {
        getPreviewFile()
    }, [])

    const handlePreview = (url, pages) => {
        setSelectedPdfUrl(null)
        setPreview(false)
        const fullUrl = `${BASE_API_URL_BOXP.replace(/\/$/, "")}${url}`;
        setTimeout(() => {
            setSelectedPdfUrl(fullUrl);
            setTotalPages(pages)

            setPreview(true);
        }, 200)


    };
    const onDocumentLoadSuccess = ({ numPages }) => {
        setTotalPages(numPages);
    };

    const closeHandler = () => {
        setDisable(true)
        const params = {
            workshop_order_id: workshopOrderId
        }
        CommercialServices.deleteApproval(params, closureData?.approved_position_id)
            .then((res) => {
                if (res.success) {
                    onClose()
                }
            })
            .catch(() => {

                onClose();

            }).finally(() => {
                setDisable(false)
            })
    }


    return (
        <div>
            <Dialog
                maxWidth={"md"}
                className={classes.modal1}
                aria-labelledby="commercial"
                // onClose={onClose}
                open={open}
            >
                <DialogTitle id="customized-dialog-title">
                    <Box style={{ display: "flex", justifyContent: "space-between" }}>
                        <Box display="flex" alignItems="center">
                            <Typography
                                style={{
                                    fontSize: "18px",
                                }}
                                color="primary"
                            >
                                Caution
                            </Typography>
                        </Box>
                        <Box display="flex" justifyContent="center">
                            {" "}
                            <img
                                src={exclamationIcon}
                                alt="Icon"
                            // style={{ height: "28px" }}
                            />{" "}
                        </Box>
                    </Box>
                </DialogTitle>



                <DialogContent style={{ marginTop: '-31px' }}>
                    {!loading ? <>
                        {planningVerfication.length > 0 &&
                            <div className={classes.message}>
                                <WarningIcon
                                    style={{
                                        color: "#FFB300",

                                        fontSize: 16,
                                        marginTop: "2px",
                                    }}
                                />&nbsp;&nbsp; <span style={{ color: "#FF0202" }}>At least one Action has NOT been Verified!</span>
                            </div>}
                        {/* 1content */}
                        {tabName === "core" ? <>
                            <div className={classes.message}>
                                <WarningIcon
                                    style={{
                                        color: "#FFB300",

                                        fontSize: 16,
                                        marginTop: "2px",
                                    }}
                                />&nbsp;&nbsp;The system will produce a Repair Report and a Core Exchange Report
                            </div>
                            <div className={classes.message}>
                                <WarningIcon
                                    style={{
                                        color: "#FFB300",

                                        fontSize: 16,
                                        marginTop: "2px",
                                    }}
                                />&nbsp;&nbsp;You are about to submit the following figures in the Repair Report for &nbsp;<u >  this  </u> &nbsp;Core Exchange item:
                            </div>
                        </> :

                            <div className={classes.message}>
                                <WarningIcon
                                    style={{
                                        color: "#FFB300",

                                        fontSize: 16,
                                        marginTop: "2px",
                                    }}
                                />&nbsp;&nbsp;You are about to submit the following figures directly to the customer:
                            </div>}

                        <Grid container xs={12} style={{
                            marginTop: "20px", marginBottom: "10px"
                        }}>
                            {tabName === "core" ? <>
                                <InfoRow label="Core Exchange #" value={popupValues?.core_exchange} />
                                <InfoRow label="Shipping" value={popupValues?.shipping} />
                                <InfoRow label="Penalties" value={popupValues?.penalities} />
                                <InfoRow label="Repair Fees" value={popupValues?.repair} />
                                <InfoRow label="Total Fees" value={popupValues?.total} />

                            </> : <>     <InfoRow label="TAT" value={popupValues?.tat_days} />
                                <InfoRow label="Labour" value={popupValues?.labour_value} />
                                <InfoRow label="Parts" value={popupValues?.parts_value} />
                                <InfoRow label="Services" value={popupValues?.service_value} />
                                <InfoRow label="Equipment" value={popupValues?.equipment_value} />
                                <InfoRow label="AOG Fee" value={popupValues?.aog_fee} />
                                <InfoRow label="Shipping" value={popupValues?.shipping} />
                                <InfoRow
                                    label="Total"
                                    value={popupValues?.total ? parseFloat(popupValues.total).toFixed(2) : ''}
                                    underline
                                /></>}
                        </Grid>
                        {closureData?.reports && closureData?.reports?.map((report, index) => (
                            <div className={classes.message} key={`caution-quote-${index}`}>
                                <WarningIcon
                                    style={{
                                        color: "#FFB300",
                                        marginRight: "10px",
                                        fontSize: 16,
                                        marginTop: "2px",
                                    }}
                                />

                                Preview the
                                <a
                                    style={{
                                        textDecoration: "underline",
                                        paddingLeft: 5,
                                        paddingRight: 5,
                                        cursor: "pointer",
                                    }}
                                    onClick={() => handlePreview(report.url, report.total_pages)}
                                >
                                    {report.name}
                                </a>
                                and check the details are correct
                            </div>
                        ))}

                        {preview && selectedPdfUrl && (
                            <>
                                <IconButton style={{
                                    position: "absolute",
                                    left: "32em",
                                    top: "17em"
                                }}
                                    onClick={() => {
                                        setTotalPages(0)
                                        setSelectedPdfUrl(null);
                                        setPreview(false);

                                    }}

                                >
                                    <Close style={{ fontSize: "27px", color: "black" }} />
                                </IconButton>
                                <Box style={{ flex: 2, marginLeft: "-36px", pointerEvents: "none" }}>


                                    <Document file={croppedPdfUrl || pdfUrl} onLoadSuccess={onDocumentLoadSuccess} key={pdfUrl}   >
                                        {Array.from(new Array(totalPages || 1), (_, index) => (
                                            <Page
                                                key={index}
                                                pageNumber={index + 1}
                                                scale={1.5}
                                                renderTextLayer={false}
                                                renderAnnotationLayer={false}
                                            />
                                        ))}
                                    </Document>
                                </Box>
                            </>
                        )}



                        <Box pt={3} display="flex" alignItems="center" style={{
                            marginLeft: "11px",
                        }}>
                            <span style={{ textDecoration: "underline" }}>Accept all</span>
                            &nbsp;&nbsp;&nbsp;
                            <input
                                style={{ pointerEvents: popupValues === undefined ? "none" : "" }}
                                type="checkbox"
                                value={acceptAll}
                                onClick={() => {
                                    setAcceptAll(!acceptAll);
                                }}
                            />
                        </Box>


                        <Box
                            mt="auto"
                            display="flex"
                            justifyContent="center"
                            style={{ marginTop: "20px", marginBottom: "20px" }}
                        >
                            <MROButton
                                style={{ marginRight: "20px" }}
                                type="button"
                                variant={"contained"}
                                onClick={() => closeHandler()}
                                buttonName="Cancel"
                                loading={disable}
                            >
                                Cancel
                            </MROButton>
                            <MROButton
                                type="button"
                                variant={"contained"}
                                disabled={disable}
                                color={"primary"}
                                style={{ backgroundColor: !acceptAll ? "#FFB300" : "", color: acceptAll ? "#ffff" : "#000000" }}
                                onClick={(e) => {
                                    acceptAll && handlePopUp(e);

                                }}
                                name="complete1"
                            >
                                Complete
                            </MROButton>
                        </Box>
                    </>
                        : (
                            <Grid style={{ textAlign: "center", marginBottom: "30px" }}>
                                <Typography className={classes.header}>
                                    The Reports for the job are being prepared
                                </Typography>
                                <img width={"150px"} src={"/loader.gif"} alt={"loading..."} />
                                <Typography className={classes.footer}>
                                    Please be patient, this will take a few moments
                                </Typography>
                            </Grid>

                        )}

                </DialogContent>



            </Dialog>


        </div>
    )
}

export default CreateApprovaCaution